import { render, staticRenderFns } from "./AllergiesSearch.vue?vue&type=template&id=3b17f074&scoped=true"
import script from "./AllergiesSearch.vue?vue&type=script&lang=js"
export * from "./AllergiesSearch.vue?vue&type=script&lang=js"
import style0 from "./AllergiesSearch.vue?vue&type=style&index=0&id=3b17f074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b17f074",
  null
  
)

export default component.exports